import Vue from 'vue';

import Checkbox from '@/components/forms/checkbox';
import ImageInput from '@/components/forms/image-input';

Vue.component('checkbox', Checkbox);
Vue.component('image-input', ImageInput);

